// @ts-nocheck
import axios from '../utils/axios';
import { ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT } from '../config';
import { catchAsync } from '../utils/api';

const loginUser = catchAsync(async ({ username, password }) => {
    const result = await axios.post(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/auth/backoffice/login`, {
        username,
        password,
    });

    return result.data;
});

const logoutUser = catchAsync(async () => {
    const result = await axios.post(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/auth/logout-backOffice`);

    return result.data;
});

const getCurrentUser = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/users/profile`);

    return result.data;
});

const createUser = catchAsync(async agent => {
    const result = await axios.post(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/users`, agent);

    return result.data;
});

const updateUser = catchAsync(async (userId, userData) => {
    const result = await axios.put(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/users/${userId}`, userData);

    return result.data;
});

const getUserList = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/users`);

    return result.data;
});

const getUser = catchAsync(async userId => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/users/${userId}`);

    return result.data;
});

const getMenus = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/menu/all`);

    return result.data;
});

const createMenu = catchAsync(async data => {
    const result = await axios.post(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/menu`, data);

    return result.data;
});

const deleteMenu = catchAsync(async id => {
    const result = await axios.delete(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/menu/${id}`);

    return result.data;
});

const getRoles = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/roles/permissions`);

    return result.data;
});

const changePassword = catchAsync(async data => {
    const result = await axios.put(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/users/change-password`, data);

    return result.data;
});

const generateQr = catchAsync(async username => {
    const result = await axios.post(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/auth/google/generate-qr`, {
        username,
    });

    return result.data;
});

const recoverQr = catchAsync(async username => {
    const result = await axios.post(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/auth/google/recover-qr`, {
        username,
    });

    return result.data;
});

const validateOtp = catchAsync(async ({ username, code }) => {
    const result = await axios.post(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/auth/google/validate-otp/key`, {
        username,
        code,
    });

    return result.data;
});

const UserService = {
    loginUser,
    logoutUser,
    getCurrentUser,
    createUser,
    updateUser,
    getUserList,
    getUser,
    getMenus,
    getRoles,
    changePassword,
    generateQr,
    validateOtp,
    recoverQr,
    createMenu,
    deleteMenu,
};

export default UserService;
